import React from 'react';
import { useLocation } from 'react-router';

export type Interrupt = {
  /** The component to render if the gate is closed. */
  component: JSX.Element;
  /** A unique id for the gate */
  id: string;
  /**
   * Blocks the rest of the application from rendering by default.
   * To render non-blocking dialogs on top of the applicaion, use false.
   */
  renderBlocking: boolean;
};

export function GlobalInterruptGate({
  blacklistedPaths = {},
  children,
  interrupts = [],
}: Readonly<{
  /** Paths that should not be interrupted by the gate. */
  blacklistedPaths?: { [path: string]: boolean };
  children: React.ReactNode;
  /** The interrupts to render. Blocking interrupts appear before nonblocking. */
  interrupts: Interrupt[];
}>) {
  const { pathname } = useLocation();
  if (blacklistedPaths[pathname]) return <>{children}</>;

  const blockingInterrupt = interrupts.find((i) => i.renderBlocking);
  const nonBlockingInterrupt = interrupts.find((i) => !i.renderBlocking);

  if (blockingInterrupt) {
    return blockingInterrupt.component;
  }

  return (
    <>
      {nonBlockingInterrupt?.component}
      {children}
    </>
  );
}
